import { Routes } from 'react-router';

import { SentryRoute as Route } from '@vk-hr-tek/core/monitoring';

import { PageError } from '../../../layout';
import { AuthById } from '../AuthById';
import { AuthList } from '../AuthList';

import { Greeting } from './Greeting';
import { Qr } from './Qr';
import { VerifyPassCode } from './VerifyPassCode';
import { Login } from './Login';
import { Register } from './Register';

export const AliAuth = () => {
  return (
    <Routes>
      <Route path="login" element={<Greeting />} />
      <Route path="qr" element={<Qr />} />
      <Route path="pass" element={<VerifyPassCode />} />
      <Route path="ali" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="auth-list" element={<AuthList />} />
      <Route path=":id">
        <Route path="*" element={<AuthById />} />
      </Route>
      <Route path="*" element={<PageError status={404} />} />
    </Routes>
  );
};
